var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiUserReceivedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2677 14.6023V16.6886C13.3642 16.3692 12.3972 16.2712 11.448 16.4029C10.4988 16.5346 9.595 16.8922 8.81259 17.4455C8.03018 17.9989 7.39197 18.7319 6.95156 19.583C6.51114 20.4341 6.28138 21.3785 6.28156 22.3368L4.28503 22.3358C4.28472 21.1168 4.56347 19.9139 5.09992 18.8193C5.63636 17.7247 6.41626 16.7674 7.37987 16.0208C8.34347 15.2742 9.4652 14.7581 10.6591 14.5121C11.853 14.266 13.0874 14.2975 14.2677 14.6023ZM12.2711 13.3524C8.9619 13.3524 6.28156 10.6721 6.28156 7.36285C6.28156 4.05361 8.9619 1.37327 12.2711 1.37327C15.5804 1.37327 18.2607 4.05361 18.2607 7.36285C18.2607 10.6721 15.5804 13.3524 12.2711 13.3524ZM12.2711 11.3559C14.4773 11.3559 16.2642 9.56901 16.2642 7.36285C16.2642 5.15669 14.4773 3.3698 12.2711 3.3698C10.065 3.3698 8.27809 5.15669 8.27809 7.36285C8.27809 9.56901 10.065 11.3559 12.2711 11.3559ZM19.6763 17.3455H23.256V19.342H19.6763L21.5021 21.1668L20.0905 22.5794L15.8549 18.3438L20.0905 14.1081L21.5021 15.5207L19.6763 17.3455Z",
    fill: "#383E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiUserReceivedLine);
export default __webpack_public_path__ + "static/media/ri_user-received-line.f1c3aac3d8821bddb78429d54ffd68d8.svg";
export { ForwardRef as ReactComponent };